/**
 * @file ui控制
 * @author mengchen <mengchen@babytree-inc.com>
 */
import React from 'react';
import ReactDOM from 'react-dom';
import { Loading as LoadingComponent, Loading2 as LoadingComponent2 } from '../components/Loading';

export const Loading = {
  isOpen: false,
  parentDom: undefined,
  loadingDom: undefined,
  open: function (props) {
    if (this.isOpen) return;
    this.parentDom = document.createElement('div');
    document.body.appendChild(this.parentDom);
    this.loadingDom = React.createRef();
    ReactDOM.render(
      <LoadingComponent
        {...props}
        loading={true}
        ref={(ref) => {
          this.loadingDom = ref;
        }}
      />,
      this.parentDom,
      () => {
        this.isOpen = true;
      }
    );
    return this.close;
  },
  close: function () {
    if (!this.isOpen) return;
    this.loadingDom.className =
      this.loadingDom.className + ' components-loading-out';
    const timeout = window.setTimeout(() => {
      if (this.parentDom) {
        ReactDOM.unmountComponentAtNode(this.parentDom);
        this.parentDom.remove();
      }
      this.parentDom = undefined;
      this.loadingDom = undefined;
      this.isOpen = false;
      window.clearTimeout(timeout);
    }, 200);
  }
};

export const Loading2 = {
  isOpen: false,
  parentDom: undefined,
  loadingDom: undefined,
  open: function (props) {
    if (this.isOpen) return;
    this.parentDom = document.createElement('div');
    document.body.appendChild(this.parentDom);
    this.loadingDom = React.createRef();
    ReactDOM.render(
      <LoadingComponent2
        {...props}
        loading={true}
        ref={(ref) => {
          this.loadingDom = ref;
        }}
      />,
      this.parentDom,
      () => {
        this.isOpen = true;
      }
    );
    return this.close;
  },
  close: function () {
    if (!this.isOpen) return;
    this.loadingDom.className =
      this.loadingDom.className + ' components-loading-out';
    const timeout = window.setTimeout(() => {
      if (this.parentDom) {
        ReactDOM.unmountComponentAtNode(this.parentDom);
        this.parentDom.remove();
      }
      this.parentDom && this.parentDom.remove();
      this.parentDom = undefined;
      this.loadingDom = undefined;
      this.isOpen = false;
      window.clearTimeout(timeout);
    }, 200);
  }
};

export const LoadingMask = {
  open: function () {
    window.bbtpage &&
      window.bbtpage.ui &&
      window.bbtpage.ui.loading &&
      window.bbtpage.ui.loading.open &&
      window.bbtpage.ui.loading.open();
  },
  close: function () {
    window.bbtpage &&
      window.bbtpage.ui &&
      window.bbtpage.ui.loading &&
      window.bbtpage.ui.loading.close &&
      window.bbtpage.ui.loading.close();
  }
};
